import service from './request';

export function getNewsCategories() { return service.get('/api/front/news/categories'); }
export function getNewsList(params?: any) { return service.get('/api/front/news', { params }); }
export function getNewsById(id: number) { return service.get('/api/front/news/' + id); }
